import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function TrustSection() {
  const { t } = useTranslation('home');

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="bg-foreground-950 rounded-3xl overflow-hidden relative flex flex-col lg:flex-row">
          <div className="absolute top-6 left-6 md:top-10 md:left-10 text-accent-500/20 text-8xl md:text-9xl font-serif leading-none select-none pointer-events-none">
            &ldquo;
          </div>

          <div className="lg:w-[35%] relative">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20stylish%20European%20man%20in%20his%20early%20thirties%20with%20short%20well%20groomed%20dark%20hair%20wearing%20a%20soft%20cashmere%20oatmeal%20sweater%20leaning%20against%20an%20exposed%20brick%20wall%20in%20a%20modern%20industrial%20cafe%20setting%20warm%20diffused%20window%20light%20from%20side%20creating%20gentle%20modeling%20on%20face%20genuine%20confident%20smile%20relaxed%20approachable%20demeanor%20editorial%20lifestyle%20portrait%20photography%20shallow%20depth%20of%20field%20natural%20skin%20texture&width=600&height=800&seq=trust-portrait-v7&orientation=portrait"
              alt="CSSBuy Spreadsheet user testimonial"
              title="CSSBuy Spreadsheet - Depoimento de usuário"
              className="w-full h-80 lg:h-full object-cover object-top"
            />
          </div>

          <div className="lg:w-[65%] p-8 md:p-12 lg:p-16 flex flex-col justify-center relative z-10">
            <p className="text-lg md:text-2xl text-background-50 font-heading leading-relaxed mb-8 italic">
              {t('trust_quote')}
            </p>
            <div className="mb-8">
              <p className="text-sm font-semibold text-background-50">{t('trust_name')}</p>
              <p className="text-xs text-foreground-400">{t('trust_role')}</p>
            </div>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-50 text-sm font-semibold rounded-full hover:bg-accent-600 transition-colors whitespace-nowrap w-fit cursor-pointer"
            >
              {t('trust_cta')}
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}